export default __webpack_public_path__ + "static/media/19253118171536669843.9b1b6fdf.svg";